// Based on code from react-key-press found here: https://github.com/jacobbuck/react-use-keypress/blob/master/src/index.js
// Used with permission:
// Copyright (c) 2021 Jacob Buck

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

import { useEffect, useRef } from 'react'

const useKeypress = (keys, handler) => {
    const eventListenerRef = useRef()

    useEffect(() => {
        eventListenerRef.current = (event) => {
            if (
                Array.isArray(keys)
                    ? keys.includes(event.key)
                    : keys === event.key
            ) {
                handler(event)
            }
        }
    }, [keys, handler])

    useEffect(() => {
        const eventListener = (event) => {
            eventListenerRef.current(event)
        }
        window.addEventListener('keydown', eventListener)
        return () => {
            window.removeEventListener('keydown', eventListener)
        }
    }, [])
}

export default useKeypress
